import { useLoaderData, useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import TextInput from "../../components/Selectors/TextInput";
import IconButton from "../../components/IconButton";
import { MdArrowLeft as Prev } from "react-icons/md";
import { edit } from "../../reducers/dataSlice";
import { toast } from "react-toastify";
import { PrimaryButton } from "../Buttons/Button";
import { putDataApi } from "../../axios/DataManagementApi";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../../utils/common";

const ObservedSystemEdit = () => {
  const { t } = useTranslation(["common", "button", "toast"]);

  const dataloaded = useLoaderData();
  const dispatch = useDispatch();
  const redirect = "/";
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const history = useNavigate();
  const [item, setItem] = useState(dataloaded);
  const onChange = (name, value) => {
    setItem((prevState) => {
      return { ...prevState, [name]: value };
    });
  };

  return (
    <div className="m-8  rounded-lg bg-white px-8 pb-8  pt-4 shadow-lg">
      <div className="flex gap-x-1.5">
        <IconButton bg={true} Icon={<Prev size={40} />} value={""} callback={() => history(redirect)} />
        <h2 className="text-3xl font-semibold text-blue-900">{capitalizeFirstLetter(t("observed_system"))}</h2>
      </div>
      <div className={"grid grid-cols-2 gap-4  border-b pb-2"}>
        <TextInput name={"name"} value={item?.name} onChange={onChange} label={capitalizeFirstLetter(t("name"))} />
        <TextInput name={"description"} value={item?.description} onChange={onChange} label={capitalizeFirstLetter(t("description"))} />
      </div>
      <div className={"flex justify-end gap-2 pt-2 "}>
        <PrimaryButton
          isLoading={isLoading}
          label={t("edit", { ns: "button" })}
          callback={() => {
            setIsLoading(true);
            putDataApi("observed_system?observed_system_id=" + id, {
              name: item.name,
              description: item.description,
            })
              .then((res) => {
                console.debug(res);
                dispatch(edit({ type: "observed_system", updates: item, id: id }));
                setIsLoading(false);
                toast.success(t("OBS_EDIT", { ns: "toast" }));
                history(redirect);
              })
              .catch((error) => {
                console.debug(error);
              });
          }}
        />
      </div>
    </div>
  );
};
export default ObservedSystemEdit;
